<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList @select="getUnit" @getFirst="getOne"></unitList> -->
      <!-- <unitList

       v-show="!($store.state.user.userInfo.natureId==2)"

        @select="getUnit"
        @getFirst="getOne"
      ></unitList> -->
      <div class="flex1">
        <div class="common-page common-head">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            文物档案
          </div>
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar" style="justify-content: space-between">
            <div class="flex ml20">
              <div class="ml20 nowBox">
                <div style="color:#3d62de;font-size:18px">
                  <p>在册</p>
                  <p>{{ total }}</p>
                </div>
              </div>
            </div>
            <div class="flex">
              <div v-hasPermi="['culturalRelics:wenwuBasicInformation:list']" class="ml20" @click="showDia = true">
                <el-button icon="el-icon-search" type="primary">查询</el-button>
              </div>
              <div v-hasPermi="['culturalRelics:wenwuBasicInformation:export']" class="ml20" @click="output">
                <el-button type="success">导出</el-button>
              </div>
              <!-- type:  0 只查看  1 可编辑   page:0 演练记录 1 灭火记录  -->

              <!-- v-hasPermi="['wenwu:fileindex:add']" -->

              <router-link
                class="ml20"
                :to="{
                  path: '/wenwu/files/add',
                  query: { type: 1, page: 1 },
                }"
                v-hasPermi="['culturalRelics:wenwuBasicInformation:add']"
                ><el-button type="primary">新增建筑</el-button></router-link
              >
            </div>
          </div>
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <el-table-column prop="buildName" label="建筑名称" align="center"></el-table-column>
              <el-table-column prop="buildNum" label="编号" align="center"></el-table-column>
              <el-table-column prop="overallAreaStr" align="center" label="总体面积(m²)"></el-table-column>

              <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

              <el-table-column prop="companyName" align="center" label="单位管理"></el-table-column>

              <el-table-column prop="createTime" align="center" label="创建日期"></el-table-column>

              <el-table-column label="操作" align="center" width="200px" fixed="right">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/wenwu/files/add',
                      query: { id: scope.row.id, view: true },
                    }"
                    v-hasPermi="['culturalRelics:wenwuBasicInformation:query']"
                  >
                    <el-button type="primary" size="mini">查看</el-button>
                  </router-link>

                  <router-link
                    :to="{
                      path: '/wenwu/files/add',
                      query: { id: scope.row.id },
                    }"
                    v-hasPermi="['culturalRelics:wenwuBasicInformation:edit']"
                  >
                    <el-button type="warning" size="mini">修改</el-button>
                  </router-link>

                  <el-popconfirm
                    title="确定删除此项吗？"
                    class="cursor"
                    @onConfirm="changeStatus(scope.row, 2)"
                    @confirm="changeStatus(scope.row, 2)"
                    v-hasPermi="['culturalRelics:wenwuBasicInformation:remove']"
                  >
                    <a slot="reference">
                      <el-button type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <!-- <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      ></fm-generate-form> -->
      <el-form ref="form" :model="form" label-width="110px">
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item label="登录密码" prop="login_pass">-->
        <!--                        <el-input v-model="form.login_pass" placeholder="请输入" ></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->

        <el-form-item label="建筑名称" prop="login_pass">
          <el-input v-model="form.buildName"></el-input>
        </el-form-item>

        <el-form-item label="开始时间:" prop="" style="width: 100%" class="flex1">
          <el-date-picker v-model="form.startDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd 00:00:00"> </el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间:" prop="" style="width: 100%" class="flex1">
          <el-date-picker v-model="form.endDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd 00:00:00"> </el-date-picker>
        </el-form-item>

        <!-- <div class="btn-box">
          <div class="l-btn" @click="onSubmit">保存</div>
          <div class="l-btn ml20" @click="$router.back()">返回</div>
        </div> -->
      </el-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import unitList from "@/components/unitList";
import qs from "qs";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: "",
      list: [],
      groups: [],
      params: {
        buildName: "",
        startDate: "",
        endDate: "",
        pageNum: 1,
        pageSize: 10,

        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      },
      form: {
        buildName: "",
        startDate: "",
        endDate: "",
      },
      messForm: {
        type: "",
        addr: "",
        ess: "",
        person: [],
      },
      people: [],
      select2: [],
      units: [],
      total: 0, // 总数
      showDia: false, // 查询
      checkAll: false, //选择全部
      showDia1: false, // 下发短信
      searchForm: this.$getForm("safePlace"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  components: { unitList },
  methods: {
    //    getOne(v){
    //      this.cpNum = v
    //  },
    //  getUnit(v){
    //      this.cpNum = v
    //  },
    //导出
    output() {
      // this.$get(
      //   "/culturalRelics/wenwuBasicInformation/export",
      //   this.params
      // ).then((res) => {
      //   console.log(this.download)
      //    this.download(res.msg)
      // });
      this.downLoadExcel("/culturalRelics/wenwuBasicInformation/export", this.params);
    },
    changetower(val, index) {
      this.units.map((item, index) => {
        if (item.dueng === val) {
          this.select2 = item.ceng;
        }
      });
    },
    handleCheckAllChange(val) {
      this.people = val ? this.groups : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.groups.length;
    },
    changeStatus(it) {
      this.$remove("/culturalRelics/wenwuBasicInformation/" + it.id).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.getList();
      });
    },
    cancle() {
      this.resetSearch();
      this.getList();
      // this.showDia = false;
    },

    // 生成二维码
    //  跳转添加
    link() {
      this.$route.push("/plan/drill-add");
    },

    getList() {
      this.$get("/culturalRelics/wenwuBasicInformation/list", this.params).then((res) => {
        this.list = res.rows;
        this.total = res.total;
      });
    },
    //  getList1(){
    //         this.$post('/score/maintenancelist',this.params).then(res=>{
    //           this.list = res.data.list
    //           this.count = res.count
    //   })
    //   },
    pageChange(val) {
      this.params.pageNum = val;
      this.getList();
    },
    searchSubmit() {
      console.log(this.form);
      this.params = { ...this.params, ...this.form };
      this.params.page = 1;
      this.getList();
      this.showDia = false;

      //  打印
    },
    resetSearch() {
      this.form = {
        buildName: "",
        startDate: "",
        endDate: "",
      };
      this.params = {
        buildName: "",
        startDate: "",
        endDate: "",
        pageNum: 1,
        pageSize: 10,
        company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
      };
    },
    // getOne(val) {
    //   this.params.c_company_num = val;
    //   this.getList()
    // },
    // getUnit(val) {
    //   this.params.c_company_num = val;
    //   this.getList()

    // },
  },
  // beforeRouteEnter(to, from, next) {
  //           console.log(from)
  //   next(vm => {
  //     if(from.name==='/plan-add'){
  //       vm.getList()
  //     }

  //     console.log(vm);
  //   });
  // },
  watch: {
    cpNum() {
      this.params.company_num = this.cpNum;
      this.params.page = 1;
      this.$post("/drill/companytowetinfo", {
        c_company_num: this.params.company_num,
      }).then((res) => {
        this.units = res.data.list;
      });
      this.getList();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
.nowBox {
  width: 200px;
  height: 80px;
  background: rgba(238, 243, 254);
  border: 1px solid #3d62de;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
